module.exports = __webpack_public_path__ + "img/loading.9dcdf537.gif";